import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User selected the thumbs up or thumbs down in the smart search feedback',
  name: 'Smart search feedback',
  params: [
    {
      description: 'The sentiment of the user',
      name: 'sentiment',
      required: true,
      type: 'enum',
      values: ['thumbs_up', 'thumbs_down'],
    },
  ],
};

export default META;
